import { useState } from "react";
import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";
import EditText from "../components/editText";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  isEdit?: boolean;
}

export default function AddCMSPage({ open, onClose, setOpen, isEdit = false }: ModalProps) {

  const [legal1, setLegal1] = useState<string>("");

  return (
    <Modal
      className="modal cmsPage_modal"
      open={open}
      onClose={() => { onClose(); }}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>{isEdit ? "Edit CMS Page" : "Add CMS Page"}</h2>

            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>

          <form className="form">
            <div className="control_group">
              <label htmlFor="">Page Title</label>
              <TextField
                fullWidth
                hiddenLabel
                placeholder="Enter Page Title"
              />
            </div>

            <div className="control_group">
              <label htmlFor="">Content Body</label>
              <EditText content={legal1} setContent={setLegal1} />
            </div>

            <div className="footer_btn_flex">
              <Button
                className="btn btn_grey"
                onClick={() => { setOpen(false); }}
              >
                Cancel
              </Button>

              <Button
                className="btn btn_primary"
                onClick={() => { setOpen(false); }}
              >
                {isEdit ? "Update" : "Submit"}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
